module.exports = __webpack_public_path__ + "static/img/loading.f48f600.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/loading.gif
// module id = lpst
// module chunks = 34